






















import Vue from 'vue'

export default Vue.extend({
  name: 'CcCapsule',

  props: {
    ccs: {
      type: Array as () => string[],
      required: true,
    },
  },

  computed: {
    hasMultipleCcs(): boolean {
      return this.ccs.length > 1
    },
    capsuleText(): string {
      if (this.ccs.length === 2) {
        return `${this.ccs[0]} & one other email…`
      } else if (this.hasMultipleCcs) {
        return `${this.ccs[0]} & ${this.ccs.length - 1} emails…`
      } else {
        return this.ccs[0]
      }
    },
  },
})
